import React, { useContext, useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import Footer from "./components/Footer"
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MainLayout from './components/MainLayout';
import {
    BrowserRouter as Router,
	Routes,
	Route,
	Navigate
} from "react-router-dom";
import SimcardList from './pages/simcard/SimcardList';
import SimcardAddEdit from './pages/simcard/pages/SimcardAddEdit';
import SensorList from './pages/sensor/SensorList';
import SensorAddEdit from './pages/sensor/pages/SensorAddEdit';
import PumpList from './pages/pump/PumpList';
import PumpAddEdit from './pages/pump/pages/PumpAddEdit';
import CustomerList from './pages/customer/CustomerList';
import CustomerAddEdit from './pages/customer/pages/CustomerAddEdit';
import PcbaList from './pages/pcba/PcbaList';
import PcbaAddEdit from './pages/pcba/pages/PcbaAddEdit';
import ApplicationBoardList from './pages/application-board/ApplicationBoardList';
import ApplicationBoardAddEdit from './pages/application-board/pages/ApplicationBoardAddEdit';
import ComponentList from './pages/component/ComponentList';
import ComponentAddEdit from './pages/component/pages/ComponentAddEdit';
import InstallationList from './pages/installation/InstallationList';
import InstallationAddEdit from './pages/installation/pages/InstallationAddEdit';
import Login from './pages/auth/Login';
import AuthProvider from './providers/AuthProvider';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { AuthRoute } from './routes/AuthRoute';
import NotFound from './pages/error/NotFound';
import Home from './pages/home/Home';
import Node from './pages/node/Node';
import Sensor1 from './pages/sensor-1/Sensor1';
import Telemetry from './pages/telemetry/Telemetry';
import Information from './pages/information/Information';
import NodeEdit from './pages/node/NodeEdit';
import SensorEdit from './pages/sensor-1/SensorEdit';
import RemoteReset from './pages/remote/RemoteReset';
import UsersList from './pages/users/UsersList';
import UsersAddEdit from './pages/users/pages/UsersAddEdit';
import SomPassed from './pages/som/SomPassed';
import AppBoardPassed from './pages/app-board/AppBoardPassed';
import CreateSerial from './pages/CreateSerial';
import DownloadContent from './pages/DownloadContent';
import InstallationAddEditV2 from './pages/installation/pages/InstallationAddEditV2';
import InstallationListV2 from './pages/installation/InstallationListV2';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'

function App() {
	return (
		<>
		
		<AuthProvider>


		<Router>

			<Routes>
				<Route path="/login" element={<Login />}/>


				<Route path="" element={
					<ProtectedRoute>
						<MainLayout currentNav='Home'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<Home/>} />
				</Route>

				<Route path="node" element={
					<ProtectedRoute>
						<MainLayout currentNav='Node'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<Node/>} />
				</Route>

				
				<Route path="sensor1" element={
					<ProtectedRoute>
						<MainLayout currentNav='Sensor'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<Sensor1/>} />
				</Route>
				
				<Route path="telemetry" element={
					<ProtectedRoute>
						<MainLayout currentNav='Telemetry'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<Telemetry/>} />
				</Route>

				<Route path="information" element={
					<ProtectedRoute>
						<MainLayout currentNav='Information'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<Information/>} />
				</Route>
				
				<Route path="node-edit" element={
					<ProtectedRoute>
						<MainLayout currentNav='Node Edit'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<NodeEdit/>} />
				</Route>
				<Route path="sensor-edit" element={
					<ProtectedRoute>
						<MainLayout currentNav='Sensor Edit'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<SensorEdit/>} />
				</Route>
				<Route path="remote-reset" element={
					<ProtectedRoute>
						<MainLayout currentNav='Remote Reset'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<RemoteReset/>} />
				</Route>

				<Route path="simcard" element={
          			<ProtectedRoute>
						<MainLayout currentNav='Simcard'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<SimcardList/>} />
					<Route path=':type' element={<SimcardAddEdit/>} />  {/*add*/}
					<Route path=':type/:id' element={<SimcardAddEdit/>} /> {/*edit*/}
				</Route>

				
				<Route path="sensor" element={
					<ProtectedRoute>
						<MainLayout currentNav='Sensor'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<SensorList/>} />
					<Route path=':type' element={<SensorAddEdit/>} />  {/*add*/}
					<Route path=':type/:id' element={<SensorAddEdit/>} /> {/*edit*/}
				</Route>

				<Route path="pump" element={
					<ProtectedRoute>
						<MainLayout currentNav='Pump'/>
					</ProtectedRoute>
				}>
					<Route path='' element={<PumpList/>} />
					<Route path=':type' element={<PumpAddEdit/>} />  {/*add*/}
					<Route path=':type/:id' element={<PumpAddEdit/>} /> {/*edit*/}
				</Route>

				<Route path="customer" element={<ProtectedRoute><MainLayout currentNav='Customer'/></ProtectedRoute>} >
					<Route path='' element={<CustomerList/>} />
					<Route path=':type' element={<CustomerAddEdit/>} />  {/*add*/}
					<Route path=':type/:id' element={<CustomerAddEdit/>} /> {/*edit*/}
				</Route>
				<Route path="component" element={<ProtectedRoute><MainLayout currentNav='Component'/></ProtectedRoute>} >
					<Route path='' element={<ComponentList/>} />
					<Route path=':type' element={<ComponentAddEdit/>} />  {/*add*/}
					<Route path=':type/:id' element={<ComponentAddEdit/>} /> {/*edit*/}
				</Route>
				{/* <Route path="installation" element={<ProtectedRoute><MainLayout currentNav='Installation'/></ProtectedRoute>} >
					<Route path='' element={<InstallationList/>} />
					<Route path=':type' element={<InstallationAddEdit/>} />
					<Route path=':type/:id' element={<InstallationAddEdit/>} />
				</Route> */}
				<Route path="installationv2" element={<ProtectedRoute><MainLayout currentNav='Installation'/></ProtectedRoute>} >
					<Route path='' element={<InstallationListV2/>} />
					<Route path=':type' element={<InstallationAddEditV2/>} />  {/*add*/}
					<Route path=':type/:id' element={<InstallationAddEditV2/>} /> {/*edit*/}
				</Route>
				<Route path="users" element={<ProtectedRoute><MainLayout currentNav='Users'/></ProtectedRoute>}>
					<Route path='' element={<UsersList/>} />
					<Route path=':type' element={<UsersAddEdit/>} /> {/*add}*/}
					<Route path=':type/:id' element={<UsersAddEdit/>} /> {/*edit*/}
				</Route>
				<Route path="som-passed" element={<ProtectedRoute><MainLayout currentNav='SOM Passed'/></ProtectedRoute>} >
					<Route path='' element={<SomPassed/>} />
				</Route>
				<Route path="app-board-passed" element={<ProtectedRoute><MainLayout currentNav='App Board Passed'/></ProtectedRoute>} >
					<Route path='' element={<AppBoardPassed/>} />
				</Route>
				
				<Route path="create-serial" element={<ProtectedRoute><MainLayout currentNav='Create Serial'/></ProtectedRoute>} >
					<Route path='' element={<CreateSerial/>} />
				</Route>
				<Route path="download-content" element={<ProtectedRoute><MainLayout currentNav='Download Content'/></ProtectedRoute>} >
					<Route path='' element={<DownloadContent/>} />
				</Route>
                <Route path="*" element={ <NotFound/> } />
			</Routes>
		</Router>
		</AuthProvider>
        <ToastContainer />
		</>
	)
}

export default App;
